import { useState } from "react";
import { Search, X } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import { Form, Input } from "reactstrap";
import { ContactTitle, Href, StartWithoutDelay } from "../../../../../Constants/Constants";
import { ContactData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { closeLeftSide } from "../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import ContactList from "./ContactList";

const Contact = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [filterText, setFilterText] = useState("");
  const FilteredItems = ContactData.filter((item) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Fragment>
      <div className="template-title">
        <div className="d-flex">
          <div>
            <h3>{ContactTitle}</h3>
            <p className="mb-0">{StartWithoutDelay}</p>
          </div>
          <div className="flex-grow-1">
            <a className="icon-btn btn-outline-light btn-sm m-r-15 search" href={Href} onClick={() => setOpen(!open)}>
              <Search />
            </a>
            <Form className={`form-inline search-form ${open && "open"}`}>
              <div className="form-group">
                <Input className="form-control-plaintext" placeholder="Search.." onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
                <div
                  className="icon-close close-search"
                  onClick={() => {
                    setFilterText("");
                    setOpen(!open);
                  }}
                >
                  <X />
                </div>
              </div>
            </Form>
            <a className="icon-btn btn-outline-light btn-sm close-panel" href={Href} onClick={() => dispatch(closeLeftSide())}>
              <X />
            </a>
          </div>
        </div>
      </div>
      <ContactList FilteredItems={FilteredItems} />
    </Fragment>
  );
};

export default Contact;
